import { useQuery } from '@tanstack/react-query';

import { AccessRoleService } from '../../services';
import { handleNucleusResponse } from '../../services/utils';

import { useAccessibleBusinesses } from '../businesses/useAccessibleBusinesses';
import { useCurrentUser } from '../users/useCurrentUser';

export const useCurrentAccessRole = () => {
  const { currentUser, isLoading: userLoading } = useCurrentUser();
  const { accessibleBusinesses, isLoading: isAccessibleBusinessesLoading } =
    useAccessibleBusinesses();

  // don't use useCurrentBusiness here because it will cause a circular dependency
  const businessId =
    currentUser?.preferences?.selectedBusinessId ??
    accessibleBusinesses?.[0]?.id; // fallback to first accessible business if no business is selected

  const QUERY_KEY = ['currentAccessRole', currentUser?.id, businessId];
  const query = useQuery({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      if (!currentUser) {
        throw new Error('No authenticated user');
      }
      if (!businessId) {
        throw new Error('No business selected');
      }
      const response =
        await AccessRoleService.fetchAccessRoleByUserIdAndBusinessId(
          currentUser.id,
          businessId
        );

      return handleNucleusResponse(response).data;
    },
    enabled:
      !!currentUser &&
      !!businessId &&
      !userLoading &&
      !isAccessibleBusinessesLoading,
  });

  const { data: currentAccessRole, isLoading, ...restQuery } = query;
  return {
    currentAccessRole,
    isLoading: isLoading || userLoading || isAccessibleBusinessesLoading,
    ...restQuery,
  };
};
